<script>
export default {
    props: ['model', 'prop', 'height','toolbar','noToolbar'],  
    data() {
        return {
           editorOptions: {
            modules: {
                toolbar: false, // 🔥 döljer hela toolbaren
            },
            theme: 'snow'
            }
        }
    },
    methods: {
        getToolbarStyle: function() {  
            return 'essential';
        }
    }
    
}
</script>
<template>  
<div :style="{ 'height': height == undefined ? '200px' : height }">
    <QuillEditor v-if=noToolbar :contentType="'html'" :options="editorOptions" v-model:content="model[prop]"></QuillEditor>
    <QuillEditor v-else :contentType="'html'" :toolbar="toolbar != undefined ? toolbar : 'essential'" v-model:content="model[prop]"></QuillEditor>
</div>
</template>
<style scoped>
   div{
    margin-bottom: 55px;
   }
</style>